<div class="menu">
  <div class="user-avatar" [matMenuTriggerFor]="userprofilemenu" [matTooltip]="userDisplayName">
    {{ userInitials }}
  </div>

  <!-- <mat-menu #userprofilemenu="matMenu" yPosition="below" [overlapTrigger]="false"> -->
  <mat-menu #userprofilemenu="matMenu">
    <div style="padding-left: 15px; padding-right: 15px">
      @if (permissionService.hasAnyPermission(adminSectionPermissions) || isSysAdmin) {
      <div>
        <div class="headingText" class="hightlight headingText" (click)="onNavigateToFirstAdminTab()">Admin
          settings</div>
        <hr style="margin: 5px" />
        @if (canReadOrg) {
        <div (click)="onNavigateToAdminSettings('orgsTab')" class="hightlight">Organisation</div>
        }
        @if (isSysAdmin) {
        <div (click)="onNavigateToAdminSettings('directories')" class="hightlight">Directories</div>
        }
        @if (canReadPermission) {
        <div (click)="onNavigateToAdminSettings('permissionTab')" class="hightlight">Permissions</div>
        }
        @if (canReadRole) {
        <div (click)="onNavigateToAdminSettings('rolesTab')" class="hightlight">Roles</div>
        }
        @if (canReadGroup) {
        <div (click)="onNavigateToAdminSettings('groupsTab')" class="hightlight">Groups</div>
        }
        @if (canReadUser) {
        <div (click)="onNavigateToAdminSettings('usersTab')" class="hightlight">Users</div>
        }
        @if (canReadLicense) {
        <div (click)="onNavigateToAdminSettings('licenseTab')" class="hightlight">License</div>
        }
        @if (canCreateExternalLink) {
        <div (click)="onNavigateToAdminSettings('externalLinksTab')" class="hightlight">Apps</div>
        }
        @if (canReadApiKey) {
        <div (click)="onNavigateToAdminSettings('apiKeysTab')" class="hightlight">API Keys</div>
        }
        @if (isSysAdmin) {
        <div (click)="onNavigateToAdminSettings('emailTab')" class="hightlight">EmailManager</div>
        } @if (isSysAdmin) {
        <div (click)="onNavigateToAdminSettings('globalTab')" class="hightlight">Global</div>
        } @if (isSysAdmin) {
        <div (click)="onNavigateToAdminSettings('migrationsTab')" class="hightlight">Migrations</div>
        } @if (canReadTemplateAll) {
        <div (click)="onNavigateToAdminSettings('blueprintsTab')" class="hightlight">Templates</div>
        }
        @if (canReadAttachment) {
        <div (click)="onNavigateToAdminSettings('attachmentsTab')" class="hightlight">Attachments</div>
        }
        @if (canReadLog) {
        <div (click)="onNavigateToAdminSettings('logsTab')" class="hightlight">Logs</div>
        }
      </div>
      }
      <div>
        <div class="headingText" style="margin-top: 15px">Profile settings</div>
        <hr style="margin: 5px" />
        <div (click)="onManageprofileandchangepwd()" class="hightlight">Profile</div>
        <div (click)="onFeedback()" class="hightlight">Feedback</div>
        <div (click)="onLogout()" class="hightlight">Logout</div>
      </div>
    </div>
  </mat-menu>
</div>
